import * as React from 'react'

interface Props {
  children?: React.ReactNode
}

export const Loader = ({ children }: Props) => (
  <div className="loader-wrapper">
    <div className="loader-spinner"></div>
    {children && <div className="loader-label">{children}</div>}
  </div>
)
